module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "theme": "dark",
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_vm._v("Solr Query builder")])]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Queries")]), _vm._v(" "), _vm._l((_vm.reports), function(report) {
    return _c('el-menu-item', {
      key: report.id,
      attrs: {
        "index": "2-1"
      }
    }, [_c('a', {
      attrs: {
        "href": '#load/' + report.id
      }
    }, [_vm._v(_vm._s(report.name))])])
  })], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/new"
    }
  }, [_vm._v("New+")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._t("default")], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec331870","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeadMenu.vue
// module id = 232
// module chunks = 1